"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Filtr_1 = require("../../../../components/Filtr/Filtr");
var hooks_1 = require("../../../../hooks");
var BlockSoudniKraj = function (_a) {
    var _b;
    var label = _a.label, value = _a.value, handleChange = _a.handleChange;
    var _c = hooks_1.useCiselnik('soudniKraje'), data = _c.data, loading = _c.loading, error = _c.error;
    if (loading) {
        return react_1.default.createElement("div", null, "loading");
    }
    if (error) {
        return react_1.default.createElement("div", null, error);
    }
    var kraj = (_b = data === null || data === void 0 ? void 0 : data.find(function (d) { return d.id === value; })) === null || _b === void 0 ? void 0 : _b.nazev;
    if (handleChange) {
        handleChange('kraj', kraj);
    }
    return (react_1.default.createElement("div", null,
        label,
        react_1.default.createElement("br", null),
        react_1.default.createElement(Filtr_1.Filtr, null, kraj)));
};
BlockSoudniKraj.defaultProps = {
    handleChange: undefined,
};
exports.default = BlockSoudniKraj;
